module.exports = __webpack_public_path__ + "media/recipes/43-9320063b.png";